// extracted by mini-css-extract-plugin
export default {"body":"Home_body__xLOJC","background":"Home_background__XRCCz","layer":"Home_layer__4jeXn"};